<style lang="less" scoped>
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 270px;
  }
  .title {
    text-align: cetner;
    font-size: 27px;
    color: #7965ef;
    line-height: 180%;
  }
  .description {
    font-size: 19px;
    margin-top: 16px;
    color: #303030;
  }
  .footer {
    display: flex;
    padding: 60px;
    border: 1px solid #e3e3e3;
    background-color: #f7f7f7;
  }
  .highlight {
    color: #ff6c00;
  }
  .footer-paragraph {
    font-size: 12px;
    margin-top: 10px;
  }
  .footer-right {
    flex: 1;
    margin-left: 120px;
  }
  footer.footer {
    border-radius: 5px;
  }
</style>

<template lang="pug">
  .review-container
    section.content
      h1.title 입점 심사 중입니다.
      p.description 심사 완료 후 연락드리겠습니다. (영업일 기준 3일 소요)
    footer.footer
      .footer-left
        p.highlight 심사항목
        p.footer-paragraph 상품 수
        p.footer-paragraph 쇼핑몰 완성도 (디자인, 인터페이스)
        p.footer-paragraph 상품 업데이트 주기
      .footer-right
        p.highlight 입점 불가 대상
        p.footer-paragraph 사업자 미등록 업체  /  패션 외 카테고리  /  고객센터, Q&A 대응이 안되는 업체
        p.footer-paragraph 전자상거래법 위반 업체 (교환, 환불)
        p.footer-paragraph 상품 상세 페이지가 회원만 접근되는 쇼핑몰
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if (localStorage.token === undefined) {
      return next('/login');
    }
    return next();
  },
};
</script>
